import { render, staticRenderFns } from "./editCommentAndFilesModal.vue?vue&type=template&id=49d069c2&"
import script from "./editCommentAndFilesModal.vue?vue&type=script&lang=js&"
export * from "./editCommentAndFilesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports